// extracted by mini-css-extract-plugin
export default {"newArticle":"styles_newArticle__TOwbF","container":"styles_container__85sgF","closeButton":"styles_closeButton__N32NN","content":"styles_content__-x8Bn"};